"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@chakra-ui/react";
import { toaster } from "@/components/ui/toaster";
import { IoIosLink } from "react-icons/io";
import { useSearchParams } from "next/navigation";

// NOTE: UI changes to this page ought to be reflected in its suspense skeleton `share-skeleton.tsx` and vice versa
// TODO: isolate the usage of `useSearchParams()` so that the Suspense boundary can be even more narrow if possible
const Share = () => {
  const $ = _c(6);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = async () => {
      ;
      try {
        const currentUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
        await navigator.clipboard.writeText(currentUrl);
        toaster.create({
          description: "Link copied",
          type: "link",
          duration: 5000,
          closable: true
        });
      } catch (t1) {
        const err = t1;
        console.error("Failed to copy: ", err);
        toaster.create({
          title: "Error",
          description: "Failed to copy link to clipboard.",
          type: "error",
          duration: 5000,
          closable: true
        });
      }
    };
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const copyLinkToClipBoard = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "grey.400"
    };
    t2 = <IoIosLink />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== copyLinkToClipBoard) {
    t3 = <Button aria-label="Copy link to this page" variant="ghost" onClick={copyLinkToClipBoard} background="transparent" textStyle="textMedium" color="white" p="0" _hover={t1}>{t2} Copy link to this page</Button>;
    $[4] = copyLinkToClipBoard;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default Share;